import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import StudentLayout from "./StudentLayout/Layout";
import AdminLayout from "./AdminLayout/Layout";

const RootLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();

  if (location.pathname.startsWith("/student")) {
    return <StudentLayout>{children}</StudentLayout>;
  }

  if (location.pathname.startsWith("/admin")) {
    return <AdminLayout>{children}</AdminLayout>;
  }

  // Default layout (e.g. login, register)
  return <main>{children}</main>;
};

export default RootLayout;